import { Collapse, Table } from 'antd';
import classnames from 'classnames';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getAssociatedCustomersData } from '../../../../redux/actions/crs/crsRiskDetail';
import { CRS_CONSTANTS } from '../../../constants/crsContants';
import {
  parseColumnsForAssociatedCustomers,
  processDataFromProps
} from '../riskDetailUtil';
import style from './index.scss';

const { GET_DATA } = CRS_CONSTANTS;
const { Panel } = Collapse;

export const AssocCustomers = ({
  customerKey,
  GSConfig,
  associatedCustomersResponse: { isFetching, fetched, customers, totalCount },
  dispatch
}) => {
  const [defaultCurrent, setDefaultCurrent] = useState(1);
  const [pageSize, setPageSize] = useState(10);

  const fetchData = (page, pageSize) =>
    dispatch(
      getAssociatedCustomersData(
        { customerKey, limit: pageSize, offset: page * pageSize },
        GET_DATA
      )
    );

  const onPaginationChange = (page, pageSize) => {
    setDefaultCurrent(page);
    setPageSize(pageSize);
    fetchData(page - 1, pageSize);
  };

  useEffect(() => {
    fetchData(defaultCurrent - 1, pageSize);
  }, []);

  useEffect(() => {
    setDefaultCurrent(1);
    fetchData(0, pageSize);
  }, [customerKey]);

  const columns = parseColumnsForAssociatedCustomers(
    GSConfig && GSConfig.widgetConfig
  );

  const tableTitle =
    GSConfig && GSConfig.widgetName && fetched
      ? `${GSConfig.widgetName} (${totalCount})`
      : 'Associated Customers';

  return (
    <div className={classnames(style.card, 'mt-3')}>
      <Collapse
        ghost
        bordered={false}
        defaultActiveKey={['1']}
        expandIconPosition="right">
        <Panel
          className={classnames(style.cardContent)}
          header={
            <div id="tableTitle" className={classnames(style.cardTitle)}>
              {tableTitle}
            </div>
          }
          key="1">
          <Table
            className={classnames(style.table)}
            dataSource={customers}
            columns={columns}
            rowKey="PRIMARY_PARTY_KEY"
            loading={isFetching}
            pagination={{
              total: totalCount,
              defaultCurrent: defaultCurrent,
              onChange: onPaginationChange,
              pageSize,
              showTotal: (total) => `${total} Records`,
              showSizeChanger: false
            }}
          />
        </Panel>
      </Collapse>
    </div>
  );
};

AssocCustomers.propTypes = {
  customerKey: PropTypes.string,
  GSConfig: PropTypes.object,
  associatedCustomersResponse: PropTypes.object,
  dispatch: PropTypes.func
};

function mapStateToProps(state, ownProps = {}) {
  const { associatedCustomersResponse } = processDataFromProps(
    state.crsRiskDetailReducer
  );
  return {
    associatedCustomersResponse: associatedCustomersResponse || {}
  };
}

function mapDispatchToProps(dispatch, ownProps = {}) {
  return {
    dispatch
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssocCustomers);
